import Center from "@/Components/Base/Center";
import LayoutLoader from "@/Components/Layout/LayoutLoader";

const Loader = () => {
  return (
    <Center className="fixed inset-0 flex h-screen w-screen items-center justify-center bg-gray-100">
      <LayoutLoader />
    </Center>
  );
};

export default Loader;
